// extracted by mini-css-extract-plugin
export default {"content":"admin_content__cBeay","main":"admin_main__j-84V"};